import React, { Component } from 'react'

export default class Motto extends Component {
    render() {
        return (
            <div>
                <p>Sit down, take a deep breath and create.
PROCESS will organize your thoughts.
This application will present your creative process.
The most important is not the end result, but the questions you'll ask along the way.</p>
            </div>
        )
    }
}
